angular.module("ticketco/ticketbuyer/redeem_items", [
  "ticketco/ticketbuyer/common"
]);
